export default __webpack_public_path__ + "static/dearself-20b15c7edd818594b911de5f70a9ae0b.jpg";